











import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "LoadingCircle",

  props: {
    small: {
      type: Boolean,
      default: false
    },
    relative: {
      type: Boolean,
      default: false
    },
    app: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    return {};
  }
});
